import SvgIcon from '@mui/material/SvgIcon';
import React from 'react';

const CustomOutput = () => {
  return (
    <SvgIcon style={{ width: '24px', height: '24px' }} viewBox="0 0 24 24">
      <g>
        <path d="M0 0h24v24H0z" fill="none" />
        <path
          transform="translate(24) rotate(90)"
          d="M2 22 v2 h20 V22 H20z m0 -12 h6 v10 h8 v-10 h4 l-8 -7 l-8 7z"
        />
      </g>
    </SvgIcon>
  );
};

export default CustomOutput;
